import { useMap } from "@vis.gl/react-google-maps";
import { Minus, Plus } from "phosphor-react-sc";

export const MapControlZoom = () => {

    const map = useMap();

    return (
        <div className="google-map-control-zoom">
            <div className="google-map-control-zoom-button" onClick={() => onZoom(1)}>
                <Plus size={20} />
            </div>
            <div />
            <div className="google-map-control-zoom-button" onClick={() => onZoom(-1)}>
                <Minus size={20} />
            </div>
        </div>
    )

    function onZoom(zoom: number) {
        if (!map) return;
        const currentZoom: number | undefined = map.getZoom();
        if (!currentZoom) return;
        map.setZoom(currentZoom + zoom);
    }
}
